import { math } from "polished";
import { DEFAULT_BREAKPOINTS } from "../../../functional/breakpointUtils";
export const mediaQueries = {
    desktopDown: `@media (max-width: ${DEFAULT_BREAKPOINTS.desktop})`,
    tabletDown: `@media (max-width:${DEFAULT_BREAKPOINTS.tablet})`,
    mobileDown: `@media (max-width:${DEFAULT_BREAKPOINTS.mobile})`,
    desktopUp: `@media (min-width:${math(`${DEFAULT_BREAKPOINTS.tablet} + 1px`)})`,
    tabletUp: `@media (min-width:${math(`${DEFAULT_BREAKPOINTS.mobile} + 1px`)})`,
    mobileUp: `@media (min-width:0px)`,
    desktopOnly: `@media (min-width: ${math(`${DEFAULT_BREAKPOINTS.tablet} + 1px`)}) and (max-width: ${DEFAULT_BREAKPOINTS.desktop})`,
    tabletOnly: `@media (min-width: ${math(`${DEFAULT_BREAKPOINTS.mobile} + 1px`)}) and (max-width: ${DEFAULT_BREAKPOINTS.desktop})`,
    mobileOnly: `@media (min-width: 0) and (max-width: ${DEFAULT_BREAKPOINTS.mobile})`,
};
//# sourceMappingURL=breakpoints.js.map